/**
 * Employee Web — `/me/travel/new` submit form route.
 *
 * Phase 19 Plan 02. RHF + Zod travel-request form gated on
 * `travel:request:self`.
 */
import type { JSX } from "react";
import { createFileRoute } from "@tanstack/react-router";
import { requirePermission } from "@linkhr/auth";
import { SubmitTravelForm } from "../features/travel/SubmitTravelForm";

export const Route = createFileRoute("/_auth/me/travel/new")({
  staticData: { breadcrumb: { labelKey: "expenses:me.travel.submit.title" } },
  beforeLoad: requirePermission({
    anyOf: ["travel:request:self"],
    defaultRoute: "/me/overview",
  }),
  component: NewTravelRoute,
});

function NewTravelRoute(): JSX.Element {
  return <SubmitTravelForm />;
}
